import apiClient from './client';

export const CustomActivityAxiosInstance = apiClient;